"use client"

import * as React from "react"
import { Theme } from "@radix-ui/themes"
import { ThemeProvider as NextThemesProvider } from "next-themes"
import { ThemeProviderProps } from "next-themes/dist/types"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...props}>
      <Theme>{children}</Theme>
    </NextThemesProvider>
  )
}
